import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementWorkingHours(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetEngagementWorkingHours`,
      "GET",
      null,
      null
    );

    context.commit("setEngagementWorkingHours", response.data);
  },

  async postEngagementWorkingHour(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementWorkingHour`,
      "POST",
      null,
      payload
    );
  },
};
